import React, { PureComponent, Fragment } from "react";

import ReactEcharts from "echarts-for-react";

export default class SunburstChart extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    var option = {
      grid: {
        height: this.props.height ? this.props.height : "auto",
      },
      tooltip: {
        trigger: "item",
        formatter: (param) => {
          if(param.treePathInfo) {
            if(param.treePathInfo.length > 2) {
              return `${param.treePathInfo[1].name} - ${param.treePathInfo[2].name}: ${param.data.value.toLocaleString()}`;
            } else {
              return `${param.data.name}: ${param.data.value.toLocaleString()}`;
            }
          }
          return '';
        },
      },
      series: [
        {
          radius: ["20%", "95%"],
          type: "sunburst",
          center: ["50%", "50%"],
          data: this.props.data,
          animation: false,
          levels: [
            {},
            {
              r0: "10%",
              r: "35%",
              itemStyle: {
                borderWidth: 2,
              },
              label: {
                show: false,
                rotate: "tangential",
              },
            },
            {
              r0: "35%",
              r: "95%",
              label: {
                show: false,
                position: 'outer',
                alignTo: 'edge',
                margin: 20
              },
            },
          ],
        },
      ],
    };
      return (<ReactEcharts
        theme="macarons"
        option={option}
        style={{ height: `${this.props.height}px` }}
      />);
  }
}